import React, { memo } from 'react'
import { motion } from 'framer-motion'
import Footer from '../../components/ui/Footer'
import '../../customstyles/CustomPageEffects.css'
import '../../customstyles/CustomMobileStyles.css'
import '../../customstyles/CustomScrollAnimations.css'
import Header from '../../components/ui/Header'
import { Link } from 'react-router-dom'
import { Stack } from 'react-bootstrap'

const Welcome = () => {
  return (
    <motion.div>
        <Header>
          <Stack direction='horizontal' gap={1} className='justify-content-center'>
                <Link to={"/appointment-management"} className='btn btn-lg btn-light bk-red my-5'><b>My Appointments</b></Link>
                <Link to={"/calendar"} className='btn btn-lg btn-light bk-turq'><b>View Calendar</b></Link>
          </Stack>
        </Header>
        
        <Footer></Footer>
    </motion.div>
  )
}

export default memo(Welcome);
